import type { ReactNode } from "react";
import { Rail } from "./Rail";
import { CommandPalette } from "./CommandPalette";
import { GlobalMaintenanceBanner } from "../GlobalMaintenanceBanner";
import { MaintenanceBanner } from "../MaintenanceBanner";
import { ScheduledRestartBanner } from "../ScheduledRestartBanner";

export const AppShell = ({ children }: { children: ReactNode }) => (
  <div className="flex h-screen w-full bg-ink text-fg font-sans overflow-hidden selection:bg-ember/30 relative">
    {/* Quiet ambient */}
    <div className="pointer-events-none absolute inset-0 z-0">
      <div className="absolute -top-[30%] left-[30%] w-[55%] h-[50%] rounded-full bg-ember/[0.05] blur-[150px]" />
      <div className="absolute inset-0 opacity-[0.35]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.03) 1px, transparent 0)", backgroundSize: "26px 26px" }} />
    </div>

    <div className="relative z-10 flex w-full h-full">
      <Rail />
      <div className="flex-1 flex flex-col overflow-hidden">
        <GlobalMaintenanceBanner />
        <MaintenanceBanner />
        <ScheduledRestartBanner />
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>

    <CommandPalette />
  </div>
);
